"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _agent = require("@deosite/agent");
var _mapCartData = require("@deosite/helpers/mapCartData");
var _createParametrizedUrl = _interopRequireDefault(require("@deosite/helpers/createParametrizedUrl"));
var _mapAddressNew = _interopRequireDefault(require("@deosite/helpers/mapAddressNew"));
var _useProductsBySkus = require("../../REST/useProductsBySkus");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getLanguageFromCustomer = function getLanguageFromCustomer(language) {
  if (language.includes("_")) {
    var match = /_(.+)/.exec(language);
    return match ? match[1].toUpperCase() : "";
  } else {
    return language.toUpperCase();
  }
};
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(cartId, token, language) {
    var _cartResponse, _cartResponse$extensi, _cartResponse$extensi2, _cartResponse$extensi3, _cartResponse2, _cartResponse$extensi4, _ref3, _shippingResponse$add, _cartResponse3, _ref4, _cartResponse$billing, _cartResponse4, _sessionStorage, _customer$email, cartResponse, _error$error, shippingResponse, isShippingMethodPicked, shippingMethodPicked, customer, totals, getProductsBySku, products, mappedProducts, findProductBySku, cartItems, currency, mappedTotals, shippingAddress, billingAddress, accountData, _customer$email2, userHasAddresses, billingAddressesCustomer, shippingAddressCustomer, _customer$addresses$f, _customer$addresses, _customer$addresses$f2, _customer$addresses2, _billingAddress$email, _billingAddress$email2, _error$error2;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if (!(token && !cartId)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            _context.prev = 3;
            _context.next = 6;
            return _agent.requests.get(token ? "/carts/mine" : "/guest-carts/".concat(cartId), false, token, language);
          case 6:
            cartResponse = _context.sent;
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            return _context.abrupt("return", (_error$error = _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.error) !== null && _error$error !== void 0 ? _error$error : _context.t0);
          case 12:
            shippingResponse = (_cartResponse = cartResponse) === null || _cartResponse === void 0 ? void 0 : (_cartResponse$extensi = _cartResponse.extension_attributes) === null || _cartResponse$extensi === void 0 ? void 0 : (_cartResponse$extensi2 = _cartResponse$extensi.shipping_assignments) === null || _cartResponse$extensi2 === void 0 ? void 0 : (_cartResponse$extensi3 = _cartResponse$extensi2[0]) === null || _cartResponse$extensi3 === void 0 ? void 0 : _cartResponse$extensi3.shipping;
            isShippingMethodPicked = !!(shippingResponse !== null && shippingResponse !== void 0 && shippingResponse.method);
            shippingMethodPicked = shippingResponse === null || shippingResponse === void 0 ? void 0 : shippingResponse.method;
            customer = cartResponse.customer;
            _context.next = 18;
            return _agent.requests.get(token ? global.__appConfig__.cartsTotalsUrl : (0, _createParametrizedUrl["default"])(global.__appConfig__.guestCartsTotalsUrl, {
              cartId: cartId
            }), false, token, language);
          case 18:
            totals = _context.sent;
            getProductsBySku = function getProductsBySku(response) {
              var skus = response.items.map(function (item) {
                return item.sku;
              });
              return (0, _useProductsBySkus.fetcher)({
                skus: skus,
                pageSize: 250,
                language: language,
                visibility: true
              });
            };
            _context.next = 22;
            return getProductsBySku(cartResponse);
          case 22:
            products = _context.sent;
            mappedProducts = products;
            findProductBySku = function findProductBySku(_ref2) {
              var sku = _ref2.sku,
                itemId = _ref2.itemId;
              var foundIndex = mappedProducts.findIndex(function (product) {
                return product.sku === sku;
              });
              if (foundIndex !== -1) {
                var _totals$items$find;
                var product = mappedProducts[foundIndex];
                var discountFromTotals = (_totals$items$find = totals.items.find(function (item) {
                  return item.item_id === itemId;
                })) === null || _totals$items$find === void 0 ? void 0 : _totals$items$find.discount_amount;
                return _objectSpread(_objectSpread({}, product), {}, {
                  price: _objectSpread(_objectSpread({}, product.price), {}, {
                    discountFromTotals: discountFromTotals
                  })
                });
              }
            };
            cartItems = cartResponse.items.map(function (cartItem) {
              return (0, _mapCartData.mapItem)(cartItem);
            });
            cartItems.forEach(function (item) {
              item.product = findProductBySku({
                sku: item.sku,
                itemId: item.itemId
              });
            });
            currency = cartResponse.currency.store_currency_code;
            mappedTotals = totals ? {
              id: cartId,
              currency: currency,
              items: cartItems,
              isShippingMethodPicked: isShippingMethodPicked,
              shippingMethodPicked: shippingMethodPicked,
              shippingAddress: isShippingMethodPicked ? (0, _mapAddressNew["default"])(_objectSpread({}, shippingResponse.address), true) : null,
              billingAddress: isShippingMethodPicked ? (0, _mapAddressNew["default"])(_objectSpread({}, (_cartResponse2 = cartResponse) === null || _cartResponse2 === void 0 ? void 0 : _cartResponse2.billing_address), true) : null,
              totals: (0, _mapCartData.mapTotals)(_objectSpread(_objectSpread({}, totals), {}, {
                ePremiaPoints: (_cartResponse$extensi4 = cartResponse.extension_attributes) === null || _cartResponse$extensi4 === void 0 ? void 0 : _cartResponse$extensi4.rewardpoints_spent
              }))
            } : {
              id: cartId,
              currency: currency,
              items: [],
              totals: {
                tax: 0,
                productsTotalPrice: 0,
                cartTotalPrice: 0,
                shippingCost: 0,
                discount: 0,
                ePremia: null,
                ePremiaPoints: null
              }
            };
            localStorage.setItem("minicartContent", JSON.stringify(_objectSpread({}, mappedTotals)));
            shippingAddress = isShippingMethodPicked || token ? (0, _mapAddressNew["default"])(_objectSpread(_objectSpread({}, shippingResponse === null || shippingResponse === void 0 ? void 0 : shippingResponse.address), {}, {
              country: [{
                id: (_ref3 = (_shippingResponse$add = shippingResponse === null || shippingResponse === void 0 ? void 0 : shippingResponse.address.country_id) !== null && _shippingResponse$add !== void 0 ? _shippingResponse$add : getLanguageFromCustomer(cartResponse.customer.created_in)) !== null && _ref3 !== void 0 ? _ref3 : language
              }]
            })) : null;
            billingAddress = isShippingMethodPicked || token ? (0, _mapAddressNew["default"])(_objectSpread(_objectSpread({}, (_cartResponse3 = cartResponse) === null || _cartResponse3 === void 0 ? void 0 : _cartResponse3.billing_address), {}, {
              country: [{
                id: (_ref4 = (_cartResponse$billing = (_cartResponse4 = cartResponse) === null || _cartResponse4 === void 0 ? void 0 : _cartResponse4.billing_address.country_id) !== null && _cartResponse$billing !== void 0 ? _cartResponse$billing : getLanguageFromCustomer(cartResponse.customer.created_in)) !== null && _ref4 !== void 0 ? _ref4 : language
              }]
            })) : null;
            accountData = JSON.parse((_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.getItem("accountData"));
            if ((customer === null || customer === void 0 ? void 0 : (_customer$email = customer.email) === null || _customer$email === void 0 ? void 0 : _customer$email.length) > 0) {
              userHasAddresses = customer.addresses.length > 0;
              billingAddressesCustomer = billingAddress;
              shippingAddressCustomer = shippingAddress;
              if (userHasAddresses && !isShippingMethodPicked) {
                billingAddressesCustomer = (_customer$addresses$f = customer.addresses.find(function (address) {
                  return address.default_billing;
                })) !== null && _customer$addresses$f !== void 0 ? _customer$addresses$f : (_customer$addresses = customer.addresses) === null || _customer$addresses === void 0 ? void 0 : _customer$addresses[0];
                billingAddressesCustomer = (0, _mapAddressNew["default"])(_objectSpread(_objectSpread({}, billingAddressesCustomer), {}, {
                  email: customer.email,
                  country: [{
                    id: billingAddressesCustomer.country_id
                  }]
                }));
              }
              if (userHasAddresses && !isShippingMethodPicked) {
                shippingAddressCustomer = (_customer$addresses$f2 = customer.addresses.find(function (address) {
                  return address.default_shipping;
                })) !== null && _customer$addresses$f2 !== void 0 ? _customer$addresses$f2 : (_customer$addresses2 = customer.addresses) === null || _customer$addresses2 === void 0 ? void 0 : _customer$addresses2[0];
                shippingAddressCustomer = (0, _mapAddressNew["default"])(_objectSpread(_objectSpread({}, shippingAddressCustomer), {}, {
                  email: customer.email,
                  country: [{
                    id: shippingAddressCustomer.country_id
                  }]
                }));
              }
              sessionStorage.setItem("accountData", JSON.stringify({
                customer: customer,
                billingAddress: userHasAddresses ? billingAddressesCustomer : billingAddress,
                shippingAddress: userHasAddresses ? shippingAddressCustomer : shippingAddress,
                email: (_customer$email2 = customer === null || customer === void 0 ? void 0 : customer.email) !== null && _customer$email2 !== void 0 ? _customer$email2 : null
              }));
            } else {
              if (accountData) {
                sessionStorage.setItem("accountData", JSON.stringify(_objectSpread(_objectSpread({}, accountData), {}, {
                  billingAddress: billingAddress,
                  shippingAddress: shippingAddress,
                  email: (_billingAddress$email = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.email) !== null && _billingAddress$email !== void 0 ? _billingAddress$email : null
                })));
              } else {
                sessionStorage.setItem("accountData", JSON.stringify({
                  billingAddress: billingAddress,
                  shippingAddress: shippingAddress,
                  email: (_billingAddress$email2 = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.email) !== null && _billingAddress$email2 !== void 0 ? _billingAddress$email2 : null
                }));
              }
            }
            return _context.abrupt("return", {
              id: cartId,
              currency: currency,
              items: cartItems,
              totals: (0, _mapCartData.mapTotals)(totals),
              isShippingMethodPicked: isShippingMethodPicked,
              shippingMethodPicked: shippingMethodPicked,
              shippingAddress: shippingAddress,
              billingAddress: billingAddress
            });
          case 37:
            _context.prev = 37;
            _context.t1 = _context["catch"](0);
            console.log(_context.t1);
            return _context.abrupt("return", (_error$error2 = _context.t1 === null || _context.t1 === void 0 ? void 0 : _context.t1.error) !== null && _error$error2 !== void 0 ? _error$error2 : _context.t1);
          case 41:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 37], [3, 9]]);
  }));
  return function fetcher(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;